import React, { useState, useEffect,useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Grid,Alert,
  MenuItem,
} from "@mui/material"; 

import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import axiosApi from "../Utils/axiosApi";
import PrintIcon from "@mui/icons-material/Print";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
const InvoiceDialog = ({ open, onClose, hosteler, onSuccess }) => {
  const [invoiceData, setInvoiceData] = useState({
    ...hosteler,
    invoiceExtraChargeDTOs: hosteler?.invoiceExtraChargeDTOs || [],
  });

  const [message, setMessage] = useState({ text: "", type: "" });
  const [saving, setSaving] = useState(false);
  const topRef = useRef(null);
const printRef = useRef();   

const paymentStatuses = [
  { value: "COMPLETED", label: "Paid" },
  { value: "PARTIALLY_COMPLETED", label: "Partially Paid" },
  { value: "PAYMENT_INITIATED", label: "Payment Initiated" },
  { value: "NOT_STARTED", label: "Pending" },
  { value: "FAILED", label: "Payment Failed" },
];
  // ------------------- Auto-calc extra charges & final amount -------------------
useEffect(() => {
  if (!invoiceData) return;

  const {
    invoiceExtraChargeDTOs = [],
    rentFinalAmount = 0,
    mealFinalAmount = 0,
    leaveRequestFoodDeduction = 0,
    closureHolidayFoodDeduction = 0,
    ownerConcessionBillAmount = 0,
    advancePaymentAmount = 0,
    previousDueAmount = 0,
    rentDeductionForHostelClosure = 0,
    rentDeductionForStudentAbsent = 0,
  } = invoiceData;

  const extraTotal = invoiceExtraChargeDTOs.reduce(
    (sum, item) => sum + (Number(item.amount) || 0),
    0
  );

  const totalDeductions =
    leaveRequestFoodDeduction +
    closureHolidayFoodDeduction +
    ownerConcessionBillAmount +
    rentDeductionForHostelClosure +
    rentDeductionForStudentAbsent +
    advancePaymentAmount;

  const finalAmount =
    rentFinalAmount +
    mealFinalAmount +
    extraTotal +
    previousDueAmount -
    totalDeductions;

  if (
    invoiceData.extraChargeTotalAmount !== extraTotal ||
    invoiceData.totalDeductions !== totalDeductions ||
    invoiceData.invoiceTotalAmount !== finalAmount
  ) {
    setInvoiceData((prev) => ({
      ...prev,
      extraChargeTotalAmount: extraTotal,
      totalDeductions,
      invoiceTotalAmount: finalAmount,
    }));
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [
  invoiceData.invoiceExtraChargeDTOs,
  invoiceData.rentFinalAmount,
  invoiceData.mealFinalAmount,
  invoiceData.leaveRequestFoodDeduction,
  invoiceData.closureHolidayFoodDeduction,
  invoiceData.ownerConcessionBillAmount,
  invoiceData.advancePaymentAmount,
  invoiceData.previousDueAmount,
  invoiceData.rentDeductionForHostelClosure,
  invoiceData.rentDeductionForStudentAbsent,
]);


  // ------------------- Update invoice data when hosteler changes -------------------
  useEffect(() => {
    const normalized = Array.isArray(hosteler)
      ? hosteler[0] || {}
      : hosteler || {};

    setInvoiceData({
      ...normalized,
      invoiceExtraChargeDTOs: normalized.invoiceExtraChargeDTOs || [],
    });
  }, [hosteler]);

useEffect(() => {
  const finalAmount = Number(invoiceData.invoiceTotalAmount || 0);
  const paidAmount = Number(invoiceData.paidAmount || 0);

  let paymentStatus = "NOT_STARTED";

  if (paidAmount <= 0) {
    paymentStatus = "NOT_STARTED";
  } else if (paidAmount < finalAmount) {
    paymentStatus = "PARTIALLY_COMPLETED";
  } else {
    paymentStatus = "COMPLETED";
  }

  if (invoiceData.paymentStatus !== paymentStatus) {
    setInvoiceData((prev) => ({
      ...prev,
      paymentStatus,
    }));
  }
}, [
  invoiceData.invoiceTotalAmount,
  invoiceData.paidAmount,
  invoiceData.paymentStatus,
]);
  // ------------------- Handlers -------------------
  const handleChange = (field, value) => {
    setInvoiceData((prev) => ({ ...prev, [field]: value }));
  };

  const handleExtraChargeChange = (index, field, value) => {
    const updated = [...invoiceData.invoiceExtraChargeDTOs];
    updated[index] = { ...updated[index], [field]: value };
    setInvoiceData((prev) => ({ ...prev, invoiceExtraChargeDTOs: updated }));
  };

  const addExtraCharge = () => {
    setInvoiceData((prev) => ({
      ...prev,
      invoiceExtraChargeDTOs: [
        ...prev.invoiceExtraChargeDTOs,
        { itemName: "", remarks: "", amount: 0 },
      ],
    }));
  };

  const removeExtraCharge = (index) => {
    const updated = [...invoiceData.invoiceExtraChargeDTOs];
    updated.splice(index, 1);
    setInvoiceData((prev) => ({ ...prev, invoiceExtraChargeDTOs: updated }));
  };
const generateInvoiceText = () => {
  const pendingAmount =
    (invoiceData.invoiceTotalAmount || 0) -
    (invoiceData.paidAmount || 0);

  const status =
    invoiceData.paymentStatus === "COMPLETED"
      ? "COMPLETED"
      : invoiceData.paymentStatus === "PARTIALLY_COMPLETED"
      ? "PARTIAL"
      : "PENDING";

  return `
HOSTEL & PG INVOICE
================================

Bill Month : ${invoiceData.billingMonth || "-"}
Bill Date  : ${new Date().toLocaleDateString()}

Customer   : ${invoiceData.hostelerName || "-"}
Hostel     : ${invoiceData.hostelName || "-"}

--------------------------------
CHARGE DETAILS
--------------------------------

Rent            ₹ ${Number(invoiceData.rentFinalAmount || 0).toFixed(2)}
Meal            ₹ ${Number(invoiceData.mealFinalAmount || 0).toFixed(2)}
Deposit         ₹ ${Number(invoiceData.depositAmount || 0).toFixed(2)}
Extra Charges   ₹ ${Number(invoiceData.extraChargeTotalAmount || 0).toFixed(2)}
Previous Due    ₹ ${Number(invoiceData.previousDueAmount || 0).toFixed(2)}
Deductions      ₹ ${Number(invoiceData.totalDeductions || 0).toFixed(2)}

--------------------------------
PAYMENT SUMMARY
--------------------------------

Total Bill      ₹ ${Number(invoiceData.invoiceTotalAmount || 0).toFixed(2)}
Paid Amount     ₹ ${Number(invoiceData.paidAmount || 0).toFixed(2)}
Pending Amount  ₹ ${Number(pendingAmount).toFixed(2)}

Status          ${status}

================================

Thank You For Staying With Us

Website : https://hostelandpg.com
`;
};
const handlePrint = () => {
  const content = generateInvoiceText().replace(/\n/g, "<br/>");

  const win = window.open("", "", "width=800,height=600");

  win.document.write(`
    <html>
      <head>
        <title>Invoice</title>
        <style>
          body { font-family: Arial; padding: 20px; }
        </style>
      </head>
      <body>
        ${content}
      </body>
    </html>
  `);

  win.document.close();
  win.print();
};
const handleWhatsApp = () => {
	 const phoneNumber = invoiceData.hostelerPhoneNumber;
	  if (!phoneNumber) return;
  const message = generateInvoiceText();
 
  const url = `https://wa.me/91${phoneNumber}?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};
 const handleSave = async () => {
    setMessage({ text: "", type: "" });
    setSaving(true);
// Ensure updatedSource = "USER"
  const updatedInvoice = {
    ...invoiceData,
    updatedSource: "USER",
  };
    const payload = {
    hostelerInvoiceDTOs: [updatedInvoice],
  };

    try {
      await axiosApi.post("/hostelerPayment/updateHostelerInvoice", payload);

      setMessage({ text: "Invoice updated successfully!", type: "success" });
topRef.current?.scrollIntoView({ behavior: "smooth" });
      
      
    } catch (err) {
      console.error("Error updating invoice:", err);
      setMessage({ text: "Error updating invoice. Try again.", type: "error" });
	  topRef.current?.scrollIntoView({ behavior: "smooth" });
    } finally {
      setSaving(false);
    }
  };

  if (!invoiceData) return null;

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") return;
        onClose();
      }}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Invoice Details</DialogTitle>

      <DialogContent dividers>
	  <div ref={topRef} />
	  
	 <div ref={printRef} style={{ display: "none" }}>
  <h2 style={{ textAlign: "center" }}>Hostel & PG Invoice</h2>

  <p><strong>Bill Month:</strong> {invoiceData.billMonth || "-"}</p>
  <p><strong>Bill Date:</strong> {new Date().toLocaleDateString()}</p>

  <hr />

  <p><strong>Name:</strong> {invoiceData.hostelerName}</p>
  <p><strong>Hostel:</strong> {invoiceData.hostelName}</p>

  <hr />

  <p><strong>Rent:</strong> ₹{invoiceData.rentFinalAmount}</p>
  <p><strong>Meal:</strong> ₹{invoiceData.mealFinalAmount}</p>
  <p><strong>Extra Charges:</strong> ₹{invoiceData.extraChargeTotalAmount}</p>
  <p><strong>Previous Due:</strong> ₹{invoiceData.previousDueAmount}</p>

  <hr />

  <p><strong>Deductions:</strong> ₹{invoiceData.totalDeductions}</p>

  <hr />

  <h3>Total: ₹{invoiceData.invoiceTotalAmount}</h3>

  <br />
  <hr />

  <p><strong>Prepared By:</strong> hostelandpg.com</p>
</div>
        {/* ================= Alert Message ================= */}
       {message.text && (
  <Alert
    severity={message.type === "error" ? "error" : "success"}
    sx={{
      position: "sticky",
      top: 0,
      zIndex: 10,
      mb: 2,
    }}
  >
    {message.text}
  </Alert>
)}

        {/* ================= Identity Section ================= */}
        <Box sx={{ border: 1, borderColor: "primary.main", borderRadius: 2, p: 2, mb: 2 }}>
          <Typography variant="subtitle1" gutterBottom>
            Identity / Hostel Info
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth label="Hosteler Name" value={invoiceData.hostelerName || ""} disabled />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField fullWidth label="Hostel Name" value={invoiceData.hostelName || ""} disabled />
            </Grid>
          </Grid>
        </Box>

        {/* ================= Amounts Section ================= */}
        <Box sx={{ border: 1, borderColor: "secondary.main", borderRadius: 2, p: 2, mb: 2 }}>
          <Typography variant="subtitle1" gutterBottom>
            Invoice Amounts
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                type="number"
                label="Meal Amount"
                value={invoiceData.mealFinalAmount || 0}
                onChange={(e) => handleChange("mealFinalAmount", Number(e.target.value))}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                type="number"
                label="Rent Amount"
                value={invoiceData.rentFinalAmount || 0}
                onChange={(e) => handleChange("rentFinalAmount", Number(e.target.value))}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField fullWidth type="number" label="Extra Charge Amount" value={invoiceData.extraChargeTotalAmount || 0} InputProps={{ readOnly: true }} />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField fullWidth type="number" label="Previous Due Amount" value={invoiceData.previousDueAmount || 0} onChange={(e) => handleChange("previousDueAmount", Number(e.target.value))} />
            </Grid>
          </Grid>
        </Box>

        {/* ================= Deductions Section ================= */}
        <Box sx={{ border: 1, borderColor: "error.main", borderRadius: 2, p: 2, mb: 2 }}>
          <Typography variant="subtitle1" gutterBottom>
            Deductions
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth type="number" label="Leave Request Food Deduction" value={invoiceData.leaveRequestFoodDeduction || 0} onChange={(e) => handleChange("leaveRequestFoodDeduction", Number(e.target.value))} />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField fullWidth type="number" label="Closure Holiday Food Deduction" value={invoiceData.closureHolidayFoodDeduction || 0} onChange={(e) => handleChange("closureHolidayFoodDeduction", Number(e.target.value))} />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField fullWidth type="number" label="RentDeduction For Hostel Closure" value={invoiceData.rentDeductionForHostelClosure || 0} onChange={(e) => handleChange("rentDeductionForHostelClosure", Number(e.target.value))} />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField fullWidth type="number" label="Rent Deduction For Student Absent" value={invoiceData.rentDeductionForStudentAbsent || 0} onChange={(e) => handleChange("rentDeductionForStudentAbsent", Number(e.target.value))} />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField fullWidth type="number" label="Owner Concession Bill Amount" value={invoiceData.ownerConcessionBillAmount || 0} onChange={(e) => handleChange("ownerConcessionBillAmount", Number(e.target.value))} />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField fullWidth type="number" label="Advance Payment Amount" value={invoiceData.advancePaymentAmount || 0} onChange={(e) => handleChange("advancePaymentAmount", Number(e.target.value))} />
            </Grid>
          </Grid>
        </Box>

        {/* ================= Attendance Section ================= */}
        <Box sx={{ border: 1, borderColor: "success.main", borderRadius: 2, p: 2, mb: 2 }}>
          <Typography variant="subtitle1" gutterBottom>
            Attendance
          </Typography>

          <TextField fullWidth label="Absent Date List" value={invoiceData.absentDateList || ""} onChange={(e) => handleChange("absentDateList", e.target.value)} placeholder="Comma separated dates" />
        </Box>

        {/* ================= Remarks Section ================= */}
        <Box sx={{ border: 1, borderColor: "warning.main", borderRadius: 2, p: 2, mb: 2 }}>
          <Typography variant="subtitle1" gutterBottom>
            Remarks / Notes
          </Typography>

          <Grid container spacing={2}>
		  <Grid item xs={12} sm={6}>
              <TextField fullWidth label="depositAmount" value={invoiceData.depositAmount } disabled />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth label="Remarks" value={invoiceData.remarks || ""} onChange={(e) => handleChange("remarks", e.target.value)} />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField fullWidth label="Updated Source" value={invoiceData.updatedSource || ""} disabled />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField fullWidth label="Hosteler Remarks" value={invoiceData.hostelerRemarks || ""} disabled />
            </Grid>

            <Grid item xs={12}>
              <TextField fullWidth label="Hostel Operator Remarks" value={invoiceData.hostelOperatorRemarks || ""} onChange={(e) => handleChange("hostelOperatorRemarks", e.target.value)} />
            </Grid>
          </Grid>
        </Box>

        {/* ================= Payment Section ================= */}
        <Box sx={{ border: 1, borderColor: "info.main", borderRadius: 2, p: 2, mb: 2 }}>
          <Typography variant="subtitle1" gutterBottom>
            Payment Details
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
 <TextField
  select
  fullWidth
  label="Payment Status"
  value={invoiceData.paymentStatus || ""}
  disabled
>
  {paymentStatuses.map((status) => (
    <MenuItem key={status.value} value={status.value}>
      {status.label}
    </MenuItem>
  ))}
</TextField>
</Grid>

            <Grid item xs={12} sm={6}>
              <TextField fullWidth label="Payment Due Date" type="date" value={invoiceData.paymentDueDate ? invoiceData.paymentDueDate.split("T")[0] : ""} onChange={(e) => handleChange("paymentDueDate", e.target.value)} InputLabelProps={{ shrink: true }} />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField fullWidth type="number" label="Paid Amount" value={invoiceData.paidAmount || 0} onChange={(e) => handleChange("paidAmount", Number(e.target.value))} />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField fullWidth label="Paid Date" type="date" value={invoiceData.paidDate || ""} onChange={(e) => handleChange("paidDate", e.target.value)} InputLabelProps={{ shrink: true }} />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField fullWidth label="Transaction ID" value={invoiceData.paymentRemarks || ""} disabled />
            </Grid>
          </Grid>
        </Box>

        {/* ================= Extra Charges Section ================= */}
        <Box sx={{ border: 1, borderColor: "grey.500", borderRadius: 2, p: 2, mb: 2 }}>
          <Typography variant="subtitle1" gutterBottom>
            Extra Charges
          </Typography>

          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Item Name</TableCell>
                <TableCell>Remarks</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell align="center">Actions</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {invoiceData.invoiceExtraChargeDTOs.map((item, idx) => (
                <TableRow key={idx}>
                  <TableCell>
                    <TextField fullWidth value={item.itemName || ""} onChange={(e) => handleExtraChargeChange(idx, "itemName", e.target.value)} />
                  </TableCell>

                  <TableCell>
                    <TextField fullWidth value={item.remarks || ""} onChange={(e) => handleExtraChargeChange(idx, "remarks", e.target.value)} />
                  </TableCell>

                  <TableCell>
                    <TextField fullWidth type="number" value={item.amount || 0} onChange={(e) => handleExtraChargeChange(idx, "amount", Number(e.target.value))} />
                  </TableCell>

                  <TableCell align="center">
                    <IconButton onClick={() => removeExtraCharge(idx)} color="error">
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          <Button startIcon={<AddIcon />} onClick={addExtraCharge} sx={{ mt: 1 }} variant="outlined">
            Add Extra Charge
          </Button>
        </Box>

        {/* ================= Final Amount ================= */}
        <Box sx={{ border: 1, borderColor: "success.main", borderRadius: 2, p: 2, mb: 2 }}>
          <Typography variant="h6">Final Amount: {invoiceData.invoiceTotalAmount || 0}</Typography>
        </Box>

      </DialogContent>

      <DialogActions
  sx={{
    px: 2,
    pb: 2,
    display: "flex",
    flexDirection: { xs: "column", sm: "row" }, // ✅ mobile responsive
    gap: 1.5,
  }}
>
  {/* Cancel */}
  <Button
    onClick={onClose}
    variant="outlined"
    fullWidth
    sx={{
      textTransform: "none",
      py: 1.2,
    }}
  >
    Cancel
  </Button>

  

<Button startIcon={<PrintIcon />}   onClick={handlePrint} >Print</Button>
<Button startIcon={<WhatsAppIcon />} onClick={handleWhatsApp}>WhatsApp</Button>
  

  {/* Save (PRIMARY ACTION) */}
  <Button
    variant="contained"
    onClick={handleSave}
    disabled={saving}
    fullWidth
    sx={{
      fontWeight: 600,
      py: 1.2,
      textTransform: "none",
    }}
  >
    {saving ? "Saving..." : "Save"}
  </Button>
</DialogActions>
    </Dialog>
  );
};

export default InvoiceDialog;
